// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AdminEventComparisonController from './admin_event_comparison_controller'
import AddressBookController from './address_book_controller'
import AddressBookContactDeleteController from './address_book_contact_delete_controller'
import ReportToolController from './report_tool_controller'
import ApexTableController from './apex_table_controller'
import ApexTableControlsController from './apex_table_controls_controller'
import ApexSensorSceneController from './apex_sensor_scene_controller'
import ApexStatisticsController from './apex_statistics_controller'
import AverageBoothScoreChartController from './average_booth_score_chart_controller'
import BleMapsController from './ble_maps_controller'
import BleStatisticsController from './ble_statistics_controller'
import BleTagHolderSelectController from './ble_tag_holder_select_controller'
import BlockListToggleController from './block_list_toggle_controller'
import CanvasRecorderController from './canvas_recorder_controller'
import ColumnSortController from './column_sort_controller'
import CompanyFilterController from './company_filter_controller'
import ContactController from './contact_controller'
import DashboardChartController from './dashboard_chart_controller'
import DashPrefixController from './dash_prefix_controller'
import DevicesController from './devices_controller'
import DragNumberController from './drag_number_controller'
import DropdownController from './dropdown_controller'
import DynamicRowsController from './dynamic_rows_controller'
import EventComparisonController from './event_comparison_controller'
import EventComparisonOrderingController from './event_comparison_ordering_controller'
import EventHistorySearchController from './event_history_search_controller'
import EventInsightsController from './event_insights_controller'
import EventInsightsTrendsController from './event_insights_trends_controller'
import EventMapBuilderController from './event_map_builder_controller'
import EventsController from './events_controller'
import EventSensorsStepFormController from './event_sensors_step_form_controller'
import ExBaseFlowchartController from './ex_base_flowchart_controller'
import ExBaseHeatmapController from './ex_base_heatmap_controller'
import ExComparisonSelectController from './ex_comparison_select_controller'
import ExCustomerJourneyController from './ex_customer_journey_controller'
import ExFlowAndJourneyController from './ex_flow_and_journey_controller'
import ExFlowchartController from './ex_flowchart_controller'
import ExHeatmapController from './ex_heatmap_controller'
import ExHeroStatisticsController from './ex_hero_statistics_controller'
import ExKpiGaugeController from './ex_kpi_gauge_controller'
import ExLineChartController from './ex_line_chart_controller'
import ExMapsController from './ex_maps_controller'
import ExRealtimeController from './ex_realtime_controller'
import ExRealtimeFlowchartController from './ex_realtime_flowchart_controller'
import ExRealtimeHeatmapController from './ex_realtime_heatmap_controller'
import ExStatisticsController from './ex_statistics_controller'
import ExSummaryDwellController from './ex_summary_dwell_controller'
import ExTreemapController from './ex_treemap_controller'
import FileDragDropController from './file_drag_drop_controller'
import FormSelectController from './form_select_controller'
import FormStepController from './form_step_controller'
import GooglePlacesController from './google_places_controller'
import GridstackController from './gridstack_controller'
import KeyboardShortcutsController from './keyboard_shortcuts_controller'
import BarChartController from '../charts/bar_chart_controller'
import LineChartController from '../charts/line_chart_controller'
import LocationController from './location_controller'
import LoaderControler from './loader_controler'
import MapCreatorToolController from '../map_creator_v2/map_creator_tool_controller'
import ModalController from './modal_controller'
import MultiSelectController from './multi_select_controller'
import NavbarController from './navbar_controller'
import PdfChartController from './pdf_chart_controller'
import radialColorFieldController from './radial_color_field_controller'
import RemovalsController from './removals_controller'
import ReleaseNotesController from './release_notes_controller'
import ReleaseNoteActionTextController from './release_note_action_text_controller'
import RequestController from './request_controller'
import SelectAllCheckboxController from './select_all_checkbox_controller'
import SensorsBulkOptionsController from './sensors_bulk_options_controller'
import SensorMapCreatorController from './sensor_map_creator_controller'
import SensorTabsController from './sensor_tabs_controller'
import SlimSelectController from './slim_select_controller'
import StepFormController from './step_form_controller'
import TableResizerController from './table_resizer_controller'
import TableColumnVisibilityController from './table_column_visibility_controller'
import TooltipController from './tooltip_controller'
import TZDatesFieldController from './tz_dates_field_controller'
import UploadPlanController from './upload_plan_controller'
import WeatherController from './weather_controller'
import YearEndEventSelectionController from './year_end_event_selection_controller'
import YearEndReportStatusController from './year_end_report_status_controller'
import YearEndScatterController from './year_end_scatter_controller'
import YearEndTemperatureController from './year_end_temperature_controller'
import PopulateEventTypeSettingsForEventDetailsStep from './populate_event_type_settings_for_event_details_step_controller'
import ChatformController from './chat_form_controller'
import ExBubbleChartController from './ex_bubble_chart_controller'
import LoadingIndicatorController from './loading_indicator_controller'
import VisitorsChartController from './visitors_chart_controller'
import ApiRoleValidationController from './api_role_validation_controller'
import NumberInputController from './number_input_controller'
import EventSummaryNavigationController from './event_summary_navigation_controller'

application.register('admin-event-comparison', AdminEventComparisonController)
application.register('address-book', AddressBookController)
application.register('address-book-contact-delete', AddressBookContactDeleteController)
application.register('report-tool', ReportToolController)
application.register('apex-table', ApexTableController)
application.register('apex-table-controls', ApexTableControlsController)
application.register('apex-sensor-scene', ApexSensorSceneController)
application.register('apex-statistics', ApexStatisticsController)
application.register('average-booth-score-chart', AverageBoothScoreChartController)
application.register('ble-maps', BleMapsController)
application.register('ble-statistics', BleStatisticsController)
application.register('ble-tag-holder-select', BleTagHolderSelectController)
application.register('block-list-toggle', BlockListToggleController)
application.register('canvas-recorder', CanvasRecorderController)
application.register('column-sort', ColumnSortController)
application.register('company-filter', CompanyFilterController)
application.register('contact', ContactController)
application.register('dashboard-chart', DashboardChartController)
application.register('dash-prefix', DashPrefixController)
application.register('drag-number', DragNumberController)
application.register('dropdown', DropdownController)
application.register('devices', DevicesController)
application.register('dynamic-rows', DynamicRowsController)
application.register('event-comparison', EventComparisonController)
application.register('event-comparison-ordering', EventComparisonOrderingController)
application.register('event-map-builder', EventMapBuilderController)
application.register('event-sensors-step-form', EventSensorsStepFormController)
application.register('ex-base-flowchart', ExBaseFlowchartController)
application.register('ex-base-heatmap', ExBaseHeatmapController)
application.register('ex-comparison-select', ExComparisonSelectController)
application.register('ex-customer-journey', ExCustomerJourneyController)
application.register('ex-flow-and-journey', ExFlowAndJourneyController)
application.register('ex-flowchart', ExFlowchartController)
application.register('ex-heatmap', ExHeatmapController)
application.register('ex-hero-statistics', ExHeroStatisticsController)
application.register('ex-kpi-gauge', ExKpiGaugeController)
application.register('ex-line-chart', ExLineChartController)
application.register('ex-maps', ExMapsController)
application.register('ex-realtime', ExRealtimeController)
application.register('ex-realtime-flowchart', ExRealtimeFlowchartController)
application.register('ex-realtime-heatmap', ExRealtimeHeatmapController)
application.register('ex-statistics', ExStatisticsController)
application.register('ex-summary-dwell', ExSummaryDwellController)
application.register('ex-treemap', ExTreemapController)
application.register('events', EventsController)
application.register('event-history-search', EventHistorySearchController)
application.register('event-insights', EventInsightsController)
application.register('event-insights-trends', EventInsightsTrendsController)
application.register('file-drag-drop', FileDragDropController)
application.register('form-select', FormSelectController)
application.register('form-step', FormStepController)
application.register('google-places', GooglePlacesController)
application.register('gridstack', GridstackController)
application.register('keyboard-shortcuts', KeyboardShortcutsController)
application.register('bar-chart', BarChartController)
application.register('line-chart', LineChartController)
application.register('location', LocationController)
application.register('loader', LoaderControler)
application.register('mct', MapCreatorToolController)
application.register('multi-select', MultiSelectController)
application.register('modal', ModalController)
application.register('navbar', NavbarController)
application.register('pdf-chart', PdfChartController)
application.register('radial-color-field', radialColorFieldController)
application.register('removals', RemovalsController)
application.register('release-notes', ReleaseNotesController)
application.register('release-note-action-text', ReleaseNoteActionTextController)
application.register('request', RequestController)
application.register('select-all-checkbox', SelectAllCheckboxController)
application.register('sensors-bulk-options', SensorsBulkOptionsController)
application.register('sensor-map-creator', SensorMapCreatorController)
application.register('sensor-tabs', SensorTabsController)
application.register('slim-select', SlimSelectController)
application.register('step-form', StepFormController)
application.register('table-resizer', TableResizerController)
application.register('table-column-visibility', TableColumnVisibilityController)
application.register('tooltip', TooltipController)
application.register('tz-dates-field', TZDatesFieldController)
application.register('upload-plan', UploadPlanController)
application.register('weather', WeatherController)
application.register('year-end-event-selection', YearEndEventSelectionController)
application.register('year-end-report-status', YearEndReportStatusController)
application.register('year-end-scatter', YearEndScatterController)
application.register('year-end-temperature', YearEndTemperatureController)
application.register('populate-event-type-settings-for-event-details-step', PopulateEventTypeSettingsForEventDetailsStep)
application.register('chat-form', ChatformController)
application.register('ex-bubble-chart', ExBubbleChartController)
application.register('loading-indicator', LoadingIndicatorController)
application.register('visitors-chart', VisitorsChartController)
application.register('api-role-validation', ApiRoleValidationController)
application.register('number-input', NumberInputController)
application.register('event-summary-navigation', EventSummaryNavigationController)
